import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Phone, Clock, MapPin, Award, Wrench, Home, Shield, Droplet, Zap, CheckCircle, Users, AlertTriangle, Gauge, Scissors, Camera, User } from 'lucide-react';
import { SchemaInjector } from '../components/SchemaInjector';

const LittletonPlumber = () => {
  // Unified Schema for the entire page
  const completePageSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://colorado-plumbing.com/littleton-plumber#webpage",
        "url": "https://colorado-plumbing.com/littleton-plumber",
        "name": "Littleton Plumber | Water Heater & Sewer Repair | Colorado First Plumbing",
        "description": "Your trusted Littleton plumber with transparent pricing. Get a 40-gal water heater for $2,000 or a sewer spot repair for $5,000. 360 Google Reviews. No hidden fees.",
        "isPartOf": { "@id": "https://colorado-plumbing.com/#website" },
        "breadcrumb": { "@id": "https://colorado-plumbing.com/littleton-plumber#breadcrumb" }
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://colorado-plumbing.com/littleton-plumber#breadcrumb",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://colorado-plumbing.com/" },
          { "@type": "ListItem", "position": 2, "name": "Littleton Plumber", "item": "https://colorado-plumbing.com/littleton-plumber" }
        ]
      },
      {
        "@type": "Plumber",
        "@id": "https://colorado-plumbing.com/",
        "name": "Colorado First Plumbing and Sewer LLC",
        "image": "https://colorado-plumbing.com/colorado-plumbing-uploads/brand/Colorado-First-Plumbing-Logo-Transparent.png",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "5108 Sydney Ave",
          "addressLocality": "Littleton",
          "addressRegion": "CO",
          "postalCode": "80130",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 39.6135,
          "longitude": -105.0178
        },
        "url": "https://colorado-plumbing.com/",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "360"
        },
        "areaServed": [
          { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
          { "@type": "City", "name": "Ken Caryl Ranch", "addressRegion": "CO" },
          { "@type": "City", "name": "Columbine", "addressRegion": "CO" },
          { "@type": "City", "name": "Bow Mar", "addressRegion": "CO" },
          { "@type": "City", "name": "Chatfield", "addressRegion": "CO" }
        ],
        "openingHours": "Mo-Sa 08:00-17:00",
        "priceRange": "$95-$12000",
        "email": "codee@colorado-plumbing.com",
        "sameAs": [
          "https://www.google.com/search?q=colorado+first+plumbing",
          "https://www.birdeye.com/colorado-first-plumbing-172384402926614",
          "https://www.homeadvisor.com/rated.ColoradoFirstPlumbing.172384402926614.html"
        ],
        "service": [
          {
            "@type": "Service",
            "name": "Water Heater Installation - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Water heater replacement in Littleton including Rheem 40-gallon ($2,000), 50-gallon ($2,100), and Bradford White models ($2,300-$2,400)",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Tankless Water Heater - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Tankless water heater replacement ($5,000) and new installation ($8,000) in Littleton with Navien and Rinnai units",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Sewer Root Removal - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Professional sewer root removal in Littleton starting at $495 using specialized Milwaukee cutting equipment",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Sewer Spot Repair - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Sewer spot repair in Littleton yards for $5,000 including excavation, repair, and permits",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Sewer Line Replacement - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Complete sewer line replacement in Littleton for $12,000 using trenchless pipe bursting technology",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Sewer Camera Inspection - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Professional sewer camera inspection in Littleton for $175 with detailed video report",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Hydro Jetting - Littleton",
            "serviceType": "Plumbing Service",
            "description": "High-pressure hydro jetting service in Littleton for $695 to clear stubborn blockages",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          },
          {
            "@type": "Service",
            "name": "Diagnostic Services - Littleton",
            "serviceType": "Plumbing Service",
            "description": "Plumbing diagnostic services in Littleton starting at $95 for standard diagnosis",
            "areaServed": { "@type": "City", "name": "Littleton", "addressRegion": "CO" },
            "provider": { "@id": "https://colorado-plumbing.com/" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question", "name": "How much does sewer root removal cost in Littleton?",
            "acceptedAnswer": { "@type": "Answer", "text": "Colorado First Plumbing offers professional sewer root removal in Littleton for $495 from basement cleanout access, $695 through toilet access, or $795 with complete video documentation. This is more effective than basic hydro jetting for aggressive tree root problems common in Littleton neighborhoods with mature trees." }
          },
          {
            "@type": "Question", "name": "What is the cost of a 40 gallon water heater replacement in Littleton?",
            "acceptedAnswer": { "@type": "Answer", "text": "A 40-gallon water heater replacement in Littleton costs $2,000 during our summer special (Rheem or AO Smith atmospheric vented). This all-inclusive price covers the water heater, professional installation to current IPC codes, thermal expansion tank, drain pan, new flex water lines, gas drip leg, permits, and disposal of your old unit." }
          },
          {
            "@type": "Question", "name": "How much does a 50 gallon water heater cost in Littleton?",
            "acceptedAnswer": { "@type": "Answer", "text": "A 50-gallon water heater replacement in Littleton costs $2,100 for a Rheem or AO Smith model. This includes complete installation with all parts, permits, and disposal of your old unit." }
          },
          {
            "@type": "Question", "name": "What is the price for a Bradford White water heater in Littleton?",
            "acceptedAnswer": { "@type": "Answer", "text": "Bradford White water heater prices in Littleton are $2,300 for a 40-gallon model and $2,400 for a 50-gallon model. These premium units come with complete installation, all parts, permits, and disposal included." }
          },
          {
            "@type": "Question", "name": "How much does a sewer spot repair cost in your Littleton yard?",
            "acceptedAnswer": { "@type": "Answer", "text": "Colorado First Plumbing charges a flat rate of $5,000 for sewer spot repair in your Littleton yard. This comprehensive price includes excavation, installation of double cleanouts, high-quality piping, proper transitional strongback couplings, bedding, and thorough post-repair inspection. This transparent pricing allows informed decisions without hidden fees." }
          },
          {
            "@type": "Question", "name": "What is the cost for collapsed sewer line replacement in Littleton?",
            "acceptedAnswer": { "@type": "Answer", "text": "For complete collapsed sewer line replacement in Littleton, Colorado First Plumbing offers a flat rate of $12,000 for full trenchless pipe bursting replacement. This includes all new piping, the pipe bursting process, bedding, professional installation, and all required permits and inspections." }
          },
          {
            "@type": "Question", "name": "How much does tankless water heater installation cost in Littleton?",
            "acceptedAnswer": { "@type": "Answer", "text": "The cost for tankless water heater installation in Littleton is $5,000 to replace an existing unit or $8,000 for new installation converting from a traditional tank. Colorado First Plumbing provides exact, flat-rate prices including the Navien or Rinnai unit, all venting, necessary gas line adjustments, and permits." }
          }
        ]
      }
    ]
  };

  useEffect(() => {
    // SEO meta tags setup
    document.title = "Littleton Plumber | Colorado First Plumbing | Real Prices";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Littleton\'s ONLY plumber showing actual prices online. Sewer scope $175, water heater $2,000. 360 Google Reviews. Master plumber owned. Same-day service.');
    }

    // BirdEye widget loading
    const loadBirdEyeWidget = () => {
      const existingScript = document.querySelector('#birdeye-widget-script');
      if (existingScript) return;

      const script = document.createElement('script');
      script.id = 'birdeye-widget-script';
      script.type = 'text/javascript';
      script.src = 'https://birdeye.com/embed/v7/172384402926614/8/9876543218815183';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };

    setTimeout(loadBirdEyeWidget, 1000);

    return () => {
      const script = document.querySelector('#birdeye-widget-script');
      if (script) script.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaInjector 
        schemas={[completePageSchema]}
        title="Littleton Plumber | Water Heater & Sewer Repair | Colorado First"
        description="Your trusted Littleton plumber with transparent pricing. Get a 40-gal water heater for $2,000 or a sewer spot repair for $5,000. 360 Google Reviews. No hidden fees."
        canonical="https://colorado-plumbing.com/littleton-plumber"
        keywords="Littleton plumber, plumber in Littleton CO, water heater Littleton, sewer repair Littleton, transparent plumbing pricing"
      />
      <Header />
      
      <main>
        {/* Hero Section - Castle Rock Style */}
        <section className="relative pt-48 pb-16 bg-gradient-to-br from-trust-primary via-authority-navy to-action-primary">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#FFFFFF_1px,transparent_1px)] [background-size:32px_32px]"></div>
          <div className="container-custom text-center relative z-10">
            {/* Trust Signals Banner */}
            <div className="inline-block px-6 py-3 mb-6 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
              <span className="text-white font-bold">🏆 Littleton's #1 Rated Family-Owned Plumbers • Licensed Master Plumber • <Link to="/team/michelle-jessen" className="text-blue-200 hover:text-blue-100 underline">Woman Majority Owned</Link> • 360 Reviews</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white leading-tight">
              Littleton Plumber with Exact Online Prices
              <span className="block text-2xl md:text-3xl mt-4 text-blue-200">
                Water Heater & Sewer Repair
              </span>
            </h1>
            
            <p className="text-xl mb-8 text-blue-100 max-w-3xl mx-auto">
              The ONLY plumber in Colorado showing exact prices online before you call. 
              No hidden fees, no "starting at" pricing, no salesmen - just transparent flat rates.
            </p>

            {/* Price Preview */}
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              <Link to="/tankless-water-heater-pricing" className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <span className="text-yellow-300 font-bold">Tankless Replace: $5,000</span>
              </Link>
              <Link to="/flat-rate-affordable-rheem-water-heaters-in-colorado" className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <span className="text-yellow-300 font-bold">40 Gal Rheem Standard: $2,000</span>
              </Link>
              <Link to="/diagnostic-services-pricing" className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <span className="text-yellow-300 font-bold">Sewer Scope: $175</span>
              </Link>
              <Link to="/sewer-replacement-spot-repair-pricing" className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <span className="text-yellow-300 font-bold">Spot Repair: $5,000</span>
              </Link>
            </div>

            {/* BirdEye Widget */}
            <div className="mb-8 max-w-2xl mx-auto">
              <div id="bf-revz-widget-9876543218815183" className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 min-h-[200px]"></div>
            </div>
            
            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              
              <Link 
                to="/pricing" 
                className="bg-gradient-to-r from-success-primary to-success-eco hover:shadow-xl hover:scale-[1.02] text-white px-10 py-5 rounded-full text-xl font-semibold inline-block transition-all duration-300"
              >
                💰 See All Exact Prices
              </Link>
            </div>

            {/* Credentials */}
            <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-white/90">
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>Licensed Master Plumber</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span><Link to="/team/michelle-jessen" className="text-blue-200 hover:text-blue-100 underline">Woman Majority Owned</Link></span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>18,000+ Jobs Since 2018</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>A+ BBB Rating</span>
              </div>
            </div>
          </div>
        </section>

        {/* Trust & Authority Section - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Why Littleton Trusts Colorado First Plumbing
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-yellow-400 mb-2">18,000+</div>
                <div className="text-lg font-semibold text-white mb-2">Jobs Completed</div>
                <p className="text-blue-100 text-sm">Since 2018 serving Littleton, Ken Caryl Ranch, Columbine, and surrounding areas</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-green-400 mb-2">360</div>
                <div className="text-lg font-semibold text-white mb-2">Reviews Online</div>
                <p className="text-blue-100 text-sm">4.8★ average across Google (360), BirdEye (300+), HomeAdvisor (92+), and other online sources</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-blue-400 mb-2">30+</div>
                <div className="text-lg font-semibold text-white mb-2">CO Jurisdictions</div>
                <p className="text-blue-100 text-sm">Licensed in 30+ Colorado cities including Littleton, with all permits and inspections handled</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-green-400 mb-2">A+</div>
                <div className="text-lg font-semibold text-white mb-2">BBB Rating</div>
                <p className="text-blue-100 text-sm">Accredited 7/15/2024</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-orange-400 mb-2">ONLY</div>
                <div className="text-lg font-semibold text-white mb-2">Licensed Plumber</div>
                <p className="text-blue-100 text-sm">Showing Affordable Prices Online with 360 Verified Reviews</p>
              </div>
            </div>
          </div>
        </section>

        {/* Master Plumber Attribution Box - NEW */}
        <section className="py-12 bg-gradient-to-br from-blue-800 to-blue-900">
          <div className="container-custom max-w-4xl">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="flex-shrink-0">
                  <img 
                    src="/page-specific-content/littleton-plumber/codee-coach-i9-with-son.jpg" 
                    alt="Codee Jessen, Licensed Master Plumber and I9 Youth Soccer Coach, with his son on the soccer field in Littleton Colorado"
                    className="w-32 h-32 rounded-full object-contain bg-white/5 border-4 border-white/20 shadow-lg"
                    loading="lazy"
                  />
                </div>
                <div className="flex-grow text-center md:text-left">
                  <h3 className="text-2xl font-bold text-white mb-2">Written by <Link to="/team/codee-jessen" className="text-blue-200 hover:text-blue-100 underline">Codee Jessen</Link>, Licensed Master Plumber</h3>
                  <div className="text-blue-100 mb-4">
                    <p className="mb-2">• Colorado Master Plumber License</p>
                    <p className="mb-2">• 18+ Years Experience</p>
                    <p className="mb-2">• 18,000+ Jobs Completed</p>
                    <p className="mb-2">• Assistant Coach: I9 Youth Soccer & Real Colorado Soccer</p>
                    <p>• Specialties: Sewer Replacement, Tankless Water Heater Installation, Multifamily Residential, Remodel & Renovation Plumbing</p>
                  </div>
                  <p className="text-sm text-blue-200 mb-4 italic">
                    "Proud to serve the Littleton and <Link to="/highlands-ranch-plumber" className="text-blue-200 hover:text-blue-100 underline">Highlands Ranch</Link> communities where my family lives and plays."
                  </p>
                  <Link to="/team/codee-jessen" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold">
                    Learn More About Our Team →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-white">
              Professional Plumbing Services in Littleton
            </h2>
            <p className="text-center text-blue-100 mb-12 max-w-3xl mx-auto">
              From <Link to="/residential-plumbing" className="text-blue-200 hover:text-blue-100 underline">emergency repairs</Link> to complete <Link to="/bathroom-kitchen-remodel" className="text-blue-200 hover:text-blue-100 underline">home remodels</Link>, we provide <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">transparent pricing</Link> for every service
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <Link to="/water-heater-pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Droplet className="w-12 h-12 text-blue-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Water Heater Replacement</h3>
                <p className="text-blue-100">Rheem and AO Smith atmospheric. 40-gallon $2,000, 50-gallon $2,100!</p>
              </Link>
              <Link to="/tankless-water-heater-pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Zap className="w-12 h-12 text-orange-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Tankless Water Heater</h3>
                <p className="text-blue-100">Replacement $5,000, new installation $8,000. Navien and Rinnai specialists.</p>
              </Link>
              <Link to="/sewer-repair-replacement" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Wrench className="w-12 h-12 text-yellow-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Sewer Repair & Replacement</h3>
                <p className="text-blue-100">Expert sewer line services with exact pricing. Spot repairs from $5,000.</p>
              </Link>
              <Link to="/sewer-cleaning-pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Shield className="w-12 h-12 text-green-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Sewer Cleaning & Scope</h3>
                <p className="text-blue-100">Camera scopes $175, professional cleaning from $495. All sewer services included.</p>
              </Link>
              <Link to="/bathroom-kitchen-remodel" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Home className="w-12 h-12 text-purple-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Remodel & Renovation</h3>
                <p className="text-blue-100">Complete plumbing for kitchen and bathroom remodels. Free estimates.</p>
              </Link>
              <Link to="/commercial-plumbing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Users className="w-12 h-12 text-indigo-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Commercial Plumbing</h3>
                <p className="text-blue-100">Licensed commercial plumbing services for Littleton businesses and properties.</p>
              </Link>
              <Link to="/pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <CheckCircle className="w-12 h-12 text-teal-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Much More</h3>
                <p className="text-blue-100"><Link to="/garbage-disposal-pricing" className="text-blue-200 hover:text-blue-100 underline">Garbage disposals</Link>, <Link to="/faucet-pricing" className="text-blue-200 hover:text-blue-100 underline">faucets</Link>, and all plumbing needs with exact pricing.</p>
              </Link>
              <Link to="/diagnostic-services-pricing" className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20">
                <Camera className="w-12 h-12 text-cyan-400 mb-4" />
                <h3 className="text-xl font-bold mb-2 text-white">Diagnostic Services</h3>
                <p className="text-blue-100">Professional diagnosis $95-$225. Annual checkups $350. Expert evaluation.</p>
              </Link>
            </div>
          </div>
        </section>

        {/* What Makes Us Different Section - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              What Makes Colorado First Plumbing Different from Other Littleton Plumbers?
            </h2>
            <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-xl mb-6 text-white font-semibold">
                We are the only Licensed Plumbing Contractor in Colorado that shows actual prices online. Flat rate pricing for <Link to="/water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">water heater replacement</Link>, <Link to="/tankless-water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">tankless water heaters</Link>, <Link to="/sewer-repair-replacement" className="text-blue-200 hover:text-blue-100 underline">sewer repair and replacement</Link>, and much more.
              </p>
              <p className="text-lg mb-6 text-blue-100">
                We believe you deserve to know the cost before you commit. We don't employ salespeople; we employ expert plumbers. Our transparent pricing model eliminates the need for high-pressure tactics.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                  <h3 className="text-xl font-bold mb-3 text-yellow-400">Example: Sewer Scope</h3>
                  <p className="text-blue-100">
                    Need to know what's wrong with your sewer? Colorado First Plumbing charges exactly <strong className="text-white">$175 for professional sewer camera inspection</strong> with written report. We publish our <Link to="/sewer-cleaning-pricing" className="text-blue-200 hover:text-blue-100 underline">exact diagnostic prices online</Link> so you can make informed decisions.
                  </p>
                </div>
                <div className="bg-white/5 rounded-lg p-6 border border-white/10">
                  <h3 className="text-xl font-bold mb-3 text-green-400">Example: Water Heater</h3>
                  <p className="text-blue-100">
                    Stop guessing what a plumber in Littleton will charge. For a <Link to="/water-heater-pricing" className="text-blue-200 hover:text-blue-100 underline">40-gallon water heater</Link>, you'll pay <strong className="text-white">$2,000 fully installed</strong>. No estimates, no hidden fees. Just <Link to="/pricing" className="text-blue-200 hover:text-blue-100 underline">transparent pricing</Link> backed by <Link to="/reviews" className="text-blue-200 hover:text-blue-100 underline">360 Google Reviews</Link>.
                  </p>
                </div>
              </div>
              
              {/* Price Comparison Cards - NEW */}
              <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-6">
                  <h3 className="text-green-400 font-bold mb-4">✅ Our Price: $5,000 (Sewer Spot Repair)</h3>
                  <ul className="text-blue-100 space-y-2">
                    <li>✓ Exact price online</li>
                    <li>✓ No hidden fees</li>
                    <li>✓ Includes everything</li>
                    <li>✓ Written guarantee</li>
                  </ul>
                </div>
                <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-6">
                  <h3 className="text-red-400 font-bold mb-4">❌ Competitors: $???</h3>
                  <ul className="text-blue-100 space-y-2">
                    <li>✗ "Free estimate"</li>
                    <li>✗ High-pressure sales</li>
                    <li>✗ Price varies by salesperson</li>
                    <li>✗ Hidden upcharges</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section 1: Root Removal - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              How Much Does Professional Sewer Cleaning Cost in Littleton?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-yellow-300">Colorado First Plumbing offers professional sewer cleaning services in Littleton including specialized root removal for $495, <Link to="/hydro-jetting-pricing" className="text-blue-200 hover:text-blue-100 underline">hydro jetting</Link> from $695, and camera scopes for $175.</strong> Our root removal service is particularly effective for the aggressive tree root problems common in Littleton neighborhoods like Ken Caryl Ranch and Columbine, where mature cottonwoods and willows frequently invade sewer lines.
              </p>
              <img 
                src="/page-specific-content/littleton-plumber/Root-removal-descale-machine.jpg" 
                alt="Professional root removal and descaling machine equipment for sewer cleaning in Littleton Colorado"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              <div className="mt-8 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">Why Root Removal vs. Hydro Jetting for Littleton Trees?</h3>
                <p className="text-blue-100 mb-4">
                  Our specialized root cutting equipment physically removes tree roots rather than just pushing them aside like <Link to="/sewer-repair-replacement" className="text-blue-200 hover:text-blue-100 underline">hydro jetting</Link>. This is crucial for Littleton's mature tree species including silver maples, ash trees, and willows that aggressively seek water in sewer lines. Our experienced plumbers have completed over 18,000 jobs and know which method works best for each situation.
                </p>
                <Link to="/root-removal-pricing" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold">
                  See Complete Root Removal Pricing →
                </Link>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-green-400">What's Included in Our $495 Root Removal Service?</h3>
                <ul className="space-y-2 text-blue-100">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Professional root cutting equipment (not just a basic <Link to="/sewer-snake-auger-pricing" className="text-blue-200 hover:text-blue-100 underline">snake</Link>)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Digital photos of notable findings during service</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Up to 75-100ft of mainline clearing</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Drainage testing post-service to ensure proper flow</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>New wax ring & bolts if accessing through toilet ($695 option)</span>
                  </li>
                </ul>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-blue-400">Professional Equipment for Aggressive Root Cutting</h3>
                <p className="text-blue-100">
                  Colorado First Plumbing uses Milwaukee professional flex shaft equipment and Spartan root cutting machines specifically designed for aggressive root removal. Unlike basic <Link to="/sewer-repair-replacement" className="text-blue-200 hover:text-blue-100 underline">drain cleaning</Link>, our equipment cuts through tough roots that have infiltrated your sewer line, providing longer-lasting results than <Link to="/hydro-jetting-pricing" className="text-blue-200 hover:text-blue-100 underline">hydro jetting</Link> alone.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 2: Sewer Spot Repair - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              How Much Does a Sewer Spot Repair Cost in Your Littleton Yard?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-yellow-300">Colorado First Plumbing charges a flat rate of $5,000 for sewer spot repair in your Littleton yard.</strong> This comprehensive price includes excavation, installation of double cleanouts, high-quality piping, proper transitional strongback couplings, bedding, and thorough post-repair inspection. Our transparent pricing allows you to make informed decisions without hidden fees or surprise charges.
              </p>
              <img 
                src="/page-specific-content/littleton-plumber/sewer-repair-outside-with-bedding-and-shoring-box-in-littleton.jpg" 
                alt="Professional sewer spot repair with proper bedding and shoring box in Littleton Colorado yard"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              <div className="mt-8 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">What's Included in Your $5,000 Littleton Yard Sewer Spot Repair?</h3>
                <ul className="space-y-2 text-blue-100">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Professional excavation with minimal yard disruption</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Installation of double cleanouts for future maintenance access</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>High-quality PVC or SDR-35 piping meeting Littleton codes</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Proper bedding material for pipe support and longevity</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Post-repair camera inspection to verify successful repair</span>
                  </li>
                </ul>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-green-400">Why Choose Spot Repair for Localized Damage in Littleton?</h3>
                <p className="text-blue-100 mb-4">
                  Sewer spot repairs are ideal for localized issues such as a single break, severe crack, or specific area of root intrusion identified via our $175 sewer camera inspection. This targeted approach minimizes excavation and disruption to your landscaping, making it a cost-effective solution for the specific problems common in older Littleton neighborhoods like Columbine and Ken Caryl Ranch with mature trees and aging clay pipes.
                </p>
                <Link to="/sewer-repair-replacement" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold">
                  Learn More About Sewer Repair Options →
                </Link>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-blue-400">Our Transparent Pricing vs. Competitors' Estimates</h3>
                <p className="text-blue-100">
                  Unlike other contractors who offer vague estimates, Colorado First Plumbing provides this exact $5,000 price online, showcasing our commitment to transparent service. This contrasts sharply with companies that rely on in-person, high-pressure sales tactics. Our team has completed over 18,000 jobs since 2018, and we stand behind our flat-rate pricing model.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 3: Collapsed Sewer Replacement - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What is the Cost for Collapsed Sewer Line Replacement in Littleton?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-yellow-300">For complete collapsed sewer line replacement in Littleton, Colorado First Plumbing offers a flat rate of $12,000 for full trenchless pipe bursting replacement.</strong> This ensures you get a permanent, modern solution with a predictable, transparent cost. Many homes in Littleton's older neighborhoods like Downtown Littleton and areas near Chatfield Reservoir have original clay pipes from the 1970s-80s that are prone to collapse.
              </p>
              <img 
                src="/page-specific-content/littleton-plumber/sewer-locate-in-littleton.jpg" 
                alt="Professional sewer line location and assessment for collapsed pipe replacement in Littleton"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              <div className="mt-8 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">Understanding Our $12,000 Flat-Rate Pipe Bursting Service in Littleton</h3>
                <p className="text-blue-100 mb-4">
                  Pipe bursting is a modern trenchless method specifically designed to replace severely damaged or collapsed pipes, like the older clay lines common in Littleton. Our price includes all new piping, the pipe bursting process if applicable, bedding, professional installation, and all required permits and inspections. This method minimizes disruption to your yard compared to traditional, full-scale excavation.
                </p>
                <ul className="space-y-2 text-blue-100 mt-4">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Complete replacement from house to city tap</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>50+ year lifespan with new PVC or HDPE pipe</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Minimal yard disruption using trenchless technology</span>
                  </li>
                </ul>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-green-400">Why Trenchless is Ideal for Littleton's Clay Pipes</h3>
                <p className="text-blue-100 mb-4">
                  This method is highly effective for cases where the old pipe is beyond simple repair, offering a long-lasting solution (up to 50+ years) that is highly resistant to root intrusion. It's a less invasive approach that saves significant time and money on landscape restoration - crucial for Littleton homes with mature landscaping.
                </p>
                <Link to="/sewer-repair-replacement" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold">
                  Learn About All Sewer Replacement Options →
                </Link>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-blue-400">Sewer Replacement Options for Ken Caryl Ranch & Columbine</h3>
                <p className="text-blue-100">
                  Many homes in Ken Caryl Ranch, Columbine, and older sections of Littleton have original clay or cast-iron lines experiencing collapsed pipes due to age, ground shifts, or severe root intrusion from the area's mature trees. Colorado First Plumbing provides this tailored, flat-rate solution to address these common local challenges, ensuring your home's infrastructure is reliable for decades to come.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 4: 40 Gallon Water Heater - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              How Much Does a 40 Gallon Water Heater Replacement Cost in Littleton?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-yellow-300">Colorado First Plumbing offers a 40-gallon water heater replacement in Littleton for $2,000 (Rheem atmospheric vented).</strong> Our standard price for a premium Bradford White 40-gallon model is $2,300. These are all-inclusive, transparent prices with no hidden fees or surprise charges.
              </p>
              <img 
                src="/page-specific-content/littleton-plumber/rheem-water-heater-installed-in-littleton.jpg" 
                alt="Professional Rheem 40-gallon water heater installation in Littleton Colorado home"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              <div className="mt-8 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">What's Included in Our $2,000 40 Gallon Water Heater Replacement Price?</h3>
                <ul className="space-y-2 text-blue-100">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>New Rheem 40-gallon atmospheric vented water heater.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Professional installation brought up to current IPC code</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Thermal expansion tank (required in Colorado)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>New drain pan and flex water lines</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Gas drip leg assembly and all permits</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Removal and proper disposal of old unit</span>
                  </li>
                </ul>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-green-400">Why Our Transparent Pricing Stands Out in Littleton</h3>
                <p className="text-blue-100 mb-4">
                  We are the only plumber in Colorado showing these exact, all-inclusive prices online. You know the final cost before you book, eliminating the stress and uncertainty of "estimate-based" services. Our experienced plumbers have installed thousands of water heaters in Littleton homes, from Ken Caryl Ranch to Downtown Littleton.
                </p>
                <Link to="/water-heater-pricing" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold">
                  See All Water Heater Models & Prices →
                </Link>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-blue-400">Common 40-Gallon Water Heater Questions for Ken Caryl Ranch & Columbine Homeowners</h3>
                <div className="space-y-4 text-blue-100">
                  <div>
                    <p className="font-semibold mb-2">Q: How much does a Bradford White 40-gallon water heater replacement cost in Littleton?</p>
                    <p>A: A standard atmospheric vented Bradford White 40-gallon water heater replacement by our experienced plumbers is $2,300. This price includes all permits, the unit, and installation.</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">Q: What are the signs I need a new water heater?</p>
                    <p>A: Common signs include leaks around the tank, rusty or discolored water, strange noises (rumbling, popping), insufficient hot water, or if your unit is over 10-12 years old.</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">Q: How much does a Bradford White 50-gallon water heater replacement cost in Littleton?</p>
                    <p>A: A standard atmospheric vented Bradford White 50-gallon water heater replacement through Colorado First Plumbing is $2,400. This price includes all permits, the unit, and installation.</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-purple-400">40-Gallon Water Heater Considerations for Chatfield & Deer Creek Homes</h3>
                <p className="text-blue-100">
                  Littleton's hard water (averaging 10-12 grains per gallon) can significantly impact water heater lifespan. That's why every installation includes a thermal expansion tank and we recommend annual <Link to="/residential-plumbing" className="text-blue-200 hover:text-blue-100 underline">flushing</Link>. Homes near Chatfield Reservoir and in Deer Creek Canyon often experience higher mineral content, making proper installation and maintenance crucial.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 5: 50 Gallon Water Heater - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              What is the Cost of a 50 Gallon Water Heater Replacement in Littleton?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-yellow-300">A 50-gallon water heater replacement in Littleton costs $2,100 for a Rheem.</strong> The standard price for a 50-gallon Bradford White model is $2,400. These are complete, "out-the-door" prices with no hidden fees or surprise charges.
              </p>
              <img 
                src="/page-specific-content/littleton-plumber/professional-water-heater-cheap-price-littleton.JPEG" 
                alt="Professional 50-gallon water heater installation at affordable price in Littleton Colorado"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              <div className="mt-8 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">Your $2,100 Rheem Water Heater Replacement in Littleton: What's Covered?</h3>
                <p className="text-blue-100 mb-4">
                  Our $2,100 special includes the 50-gallon Rheem or AO Smith unit, all necessary parts for a code-compliant installation (thermal expansion tank, pan, lines), professional labor by our licensed plumbers, permit pulling, and disposal of the old tank. This comprehensive price ensures no surprises when the job is complete.
                </p>
                <ul className="space-y-2 text-blue-100 mt-4">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>50-gallon capacity perfect for 3-5 person households</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                                      </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Energy-efficient models meeting current standards</span>
                  </li>
                </ul>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-green-400">Comparing 50-Gallon Water Heater Costs: Our Upfront Advantage</h3>
                <p className="text-blue-100 mb-4">
                  Unlike competitors who provide vague "free estimates" that often lead to high-pressure sales situations, Colorado First Plumbing shows you the exact price online. Our $2,100 summer special price is the complete cost - no add-ons, no upcharges, no surprises. We've maintained this transparent pricing model throughout our 18,000+ completed jobs.
                </p>
                <Link to="/water-heater-pricing" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold">
                  Compare All Water Heater Options & Prices →
                </Link>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-blue-400">Frequently Asked Questions About 50-Gallon Water Heaters in Downtown Littleton</h3>
                <div className="space-y-4 text-blue-100">
                  <div>
                    <p className="font-semibold mb-2">Q: What is the estimated lifespan of a traditional 50-gallon water heater?</p>
                    <p>A: Traditional tank water heaters typically last 8-12 years with proper maintenance, though Littleton's hard water can affect this. Annual <Link to="/residential-plumbing" className="text-blue-200 hover:text-blue-100 underline">flushing</Link> helps extend lifespan.</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">Q: Why choose 50-gallon over 40-gallon?</p>
                    <p>A: The extra 10 gallons provides about 20% more hot water capacity, ideal for larger families or homes with multiple bathrooms being used simultaneously.</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-purple-400">Local Insights for Bow Mar & Highlands Ranch Border Areas</h3>
                <p className="text-blue-100">
                  Homes in the Bow Mar area and along the Littleton-<Link to="/highlands-ranch-plumber" className="text-blue-200 hover:text-blue-100 underline">Highlands Ranch</Link> border often have larger soaking tubs and multiple bathroom suites, making the 50-gallon capacity essential. Our team understands the specific needs of these upscale neighborhoods and ensures proper sizing for your household's hot water demands.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ 6: Tankless Water Heater - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom max-w-4xl relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              How Much Does Tankless Water Heater Installation Cost in Littleton?
            </h2>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <p className="text-lg mb-6 text-blue-100">
                <strong className="text-yellow-300">The cost for tankless water heater installation in Littleton is $5,000 to replace an existing unit or $8,000 for new installation converting from a traditional tank.</strong> Colorado First Plumbing provides exact, flat-rate prices including the Navien or Rinnai unit, all venting, necessary gas line adjustments, professional installation, and permits.
              </p>
              <img 
                src="/page-specific-content/littleton-plumber/tankless-water-heater-professional-replacement-centennial.jpeg" 
                alt="Professional Navien tankless water heater replacement installation in Littleton Colorado"
                className="w-full rounded-lg mb-6 shadow-lg"
                loading="lazy"
              />
              
              <div className="mt-8 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-yellow-400">Understanding Your $8,000 Navien Tankless Installation Price in Littleton</h3>
                <p className="text-blue-100 mb-4">
                  For homeowners converting from a tank to a tankless system, our $8,000 flat-rate price is all-inclusive. It covers:
                </p>
                <ul className="space-y-2 text-blue-100 mt-4">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Navien NPE-210A2 or similar high-efficiency unit</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>All new venting installation (2-pipe PVC system)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Gas line upgrades if needed (3/4" minimum)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Professional programming and setup</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>All permits and inspections</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                                      </li>
                </ul>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-green-400">Benefits of Tankless Water Heaters & Our Transparent Pricing</h3>
                <div className="space-y-4 text-blue-100">
                  <div>
                    <p className="font-semibold mb-2">Q: Are tankless water heaters worth the investment in Colorado?</p>
                    <p>A: Yes, tankless water heaters can offer significant long-term savings on energy bills (up to 34% for homes using less than 41 gallons daily) and provide endless hot water. With our transparent flat-rate pricing, you know exactly what this upgrade will cost.</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">Q: What is the lifespan of a tankless water heater?</p>
                    <p>A: Tankless water heaters typically last 20 years or more with proper maintenance, which is roughly twice the lifespan of a traditional tank unit. This makes the higher upfront investment worthwhile for many Littleton homeowners.</p>
                  </div>
                </div>
                <Link to="/tankless-water-heater-pricing" className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-semibold mt-4">
                  Learn More About Tankless Options →
                </Link>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-blue-400">Tankless Water Heater FAQs for Energy-Efficient Littleton Homes</h3>
                <div className="space-y-4 text-blue-100">
                  <div>
                    <p className="font-semibold mb-2">Q: What brands of tankless water heaters do you recommend for Colorado homes?</p>
                                      </div>
                  <div>
                    <p className="font-semibold mb-2">Q: Can tankless handle Littleton's cold groundwater temperatures?</p>
                    <p>A: Yes, we properly size units to account for Littleton's 40°F winter groundwater temperatures, ensuring adequate hot water flow even in the coldest months.</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 bg-white/5 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4 text-purple-400">Tankless Options for Roxborough & Highlands Ranch Border Areas</h3>
                <p className="text-blue-100">
                  Newer construction homes in Roxborough and along the <Link to="/highlands-ranch-plumber" className="text-blue-200 hover:text-blue-100 underline">Highlands Ranch</Link> border are ideal candidates for tankless systems, often having the proper gas line sizing already in place. These energy-conscious neighborhoods appreciate both the endless hot water and the space savings of wall-mounted units. Our experienced installers have completed hundreds of tankless installations in these areas.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Common Issues Section - Dark Gradient */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Common Plumbing Issues in Littleton Neighborhoods
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="flex items-center mb-4">
                  <AlertTriangle className="w-8 h-8 text-yellow-400 mr-3" />
                  <h3 className="text-xl font-bold text-white">Clay Pipe Problems (1970s-80s Homes)</h3>
                </div>
                <p className="text-blue-100 mb-4">
                  Many homes in older Littleton neighborhoods like Columbine and Ken Caryl Ranch have original clay sewer lines that are brittle and prone to cracking. These pipes are particularly vulnerable to root intrusion and ground movement.
                </p>
                <p className="text-sm text-yellow-300">
                  Solution: Our $175 camera inspection identifies problems early. Spot repairs cost $5,000, full replacement $12,000.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="flex items-center mb-4">
                  <Droplet className="w-8 h-8 text-blue-400 mr-3" />
                  <h3 className="text-xl font-bold text-white">Tree Root Invasion</h3>
                </div>
                <p className="text-blue-100 mb-4">
                  Littleton's mature cottonwoods, willows, and silver maples aggressively seek water in sewer lines. Ken Caryl Ranch and areas near Chatfield are particularly affected due to extensive mature landscaping.
                </p>
                <p className="text-sm text-yellow-300">
                  Solution: <Link to="/root-removal-pricing" className="text-blue-200 hover:text-blue-100 underline">Root removal</Link> from $495 - more effective than <Link to="/hydro-jetting-pricing" className="text-blue-200 hover:text-blue-100 underline">hydro jetting</Link> for aggressive roots.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="flex items-center mb-4">
                  <Gauge className="w-8 h-8 text-red-400 mr-3" />
                  <h3 className="text-xl font-bold text-white">Hard Water Damage (10-12 Grains)</h3>
                </div>
                <p className="text-blue-100 mb-4">
                  Littleton's hard water causes mineral buildup in water heaters, reducing efficiency and lifespan. Homes near Chatfield Reservoir often see higher mineral content requiring pressure reducing valves.
                </p>
                <p className="text-sm text-yellow-300">
                  Solution: Annual water heater flushing ($350 with our checkup) and PRV installation when needed.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="flex items-center mb-4">
                  <AlertTriangle className="w-8 h-8 text-orange-400 mr-3" />
                  <h3 className="text-xl font-bold text-white">Winter Pipe Freezing</h3>
                </div>
                <p className="text-blue-100 mb-4">
                  Exposed pipes in crawl spaces and exterior walls are vulnerable during Colorado's winter freezes. Older homes in Downtown Littleton with inadequate insulation are especially at risk.
                </p>
                <p className="text-sm text-yellow-300">
                  Solution: <Link to="/emergency-success" className="text-blue-200 hover:text-blue-100 underline">Emergency service</Link> available during business hours. Same-day response when possible. Preventive insulation recommended.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Licensed Plumber Importance - Light Gradient */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Why Choose a Licensed Master Plumber in Littleton?
            </h2>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20 mb-8">
                <h3 className="text-2xl font-bold mb-6 text-yellow-400">Code Compliance & Safety</h3>
                <p className="text-blue-100 mb-4">
                  Colorado First Plumbing operates under Master Plumber Codee Jessen's license, ensuring all work meets the 2018 International Plumbing Code adopted by Colorado. This isn't just bureaucracy - it's about protecting your family's health and your property value.
                </p>
                <ul className="space-y-3 text-blue-100">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Proper backflow prevention to protect drinking water</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Correct venting to prevent dangerous sewer gases</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Thermal expansion tanks required on all water heaters</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                    <span>Proper permits pulled for all required work</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20 mb-8">
                <h3 className="text-2xl font-bold mb-6 text-green-400">Professional Equipment & Expertise</h3>
                <p className="text-blue-100 mb-4">
                  Our team uses specialized equipment that handymen and unlicensed contractors don't have access to:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-blue-100">
                  <div className="bg-white/5 rounded-lg p-4">
                    <strong className="text-white">Diagnostic Tools:</strong>
                    <ul className="mt-2 space-y-1 text-sm">
                      <li>• HD sewer cameras with locators</li>
                      <li>• Electronic leak detection</li>
                      <li>• Thermal imaging cameras</li>
                    </ul>
                  </div>
                  <div className="bg-white/5 rounded-lg p-4">
                    <strong className="text-white">Repair Equipment:</strong>
                    <ul className="mt-2 space-y-1 text-sm">
                      <li>• Milwaukee flex shaft root cutters</li>
                      <li>• Spartan sewer machines</li>
                      <li>• Pipe bursting equipment</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
                <h3 className="text-2xl font-bold mb-6 text-blue-400">What to Look for When Hiring in Littleton</h3>
                <div className="space-y-4 text-blue-100">
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <strong className="text-white">Valid Colorado License:</strong> Ask for their license number and verify it with the state
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <strong className="text-white">Transparent Pricing:</strong> Exact prices upfront, not vague estimates
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <strong className="text-white">Insurance & Bonding:</strong> Protection for your property
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <strong className="text-white">Local Reputation:</strong> Verifiable reviews from Littleton residents
                    </div>
                  </div>
                </div>
                <p className="mt-6 text-yellow-300 font-semibold">
                  Colorado First Plumbing meets all these criteria with <Link to="/reviews" className="text-blue-200 hover:text-blue-100 underline">360 Google Reviews</Link>, exact online pricing, and Master Plumber licensing.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Price Timestamp - NEW */}
        <section className="py-8 bg-gradient-to-br from-blue-800 to-blue-900">
          <div className="container-custom text-center">
            <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 border border-white/20">
              <CheckCircle className="w-5 h-5 text-green-400 mr-2" />
              <span className="text-white font-semibold">
                ✅ Prices verified: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </span>
            </div>
          </div>
        </section>

        {/* Final CTA Section - Dark Gradient */}
        <section className="py-20 bg-gradient-to-br from-blue-800 to-blue-900 overflow-hidden">
          <div className="container-custom text-center relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
              Ready for Honest, Transparent Plumbing Service in Littleton?
            </h2>
            <p className="text-xl mb-8 text-blue-100 max-w-3xl mx-auto">
              No hidden fees. No surprise charges. Just exact prices you can see right now.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold text-orange-400 mb-2">$5,000</div>
                <p className="text-white font-semibold">Tankless Replace</p>
                <p className="text-sm text-blue-100">Existing unit replacement</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold text-green-400 mb-2">$2,000</div>
                <p className="text-white font-semibold">40 Gal Water Heater</p>
                <p className="text-sm text-blue-100">Summer special price</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="text-3xl font-bold text-blue-400 mb-2">$5,000</div>
                <p className="text-white font-semibold">Sewer Spot Repair</p>
                <p className="text-sm text-blue-100">In your yard</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              
              <Link 
                to="/pricing" 
                className="bg-gradient-to-r from-success-primary to-success-eco hover:shadow-xl hover:scale-[1.02] text-white px-10 py-5 rounded-full text-xl font-semibold inline-block transition-all duration-300"
              >
                💰 View All Pricing Online
              </Link>
            </div>
            
            <div className="mt-8 flex flex-wrap justify-center gap-6 text-white/80">
              <span className="flex items-center gap-2">
                <MapPin className="w-5 h-5" />
                Serving all Littleton neighborhoods
              </span>
              <span className="flex items-center gap-2">
                <Clock className="w-5 h-5" />
                Mon-Sat 8AM-5PM
              </span>
              <span className="flex items-center gap-2">
                <Award className="w-5 h-5" />
                Licensed & Insured
              </span>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LittletonPlumber;